import { findMultiOpeningProductByName, computeOpeningRects } from '../../../../lib/multiOpeningMatProducts';
import { getLineItemThumbnailUrl } from '../../../../lib/utils';
import placeholderImage from '../../../../images/default-placeholder.jpg';
import styles from './MultiOpeningLineItemSummary.module.css';

export const MULTI_OPENING_THUMB_WIDTH = 100;
export const MULTI_OPENING_THUMB_HEIGHT = 100;
export const MULTI_OPENING_THUMB_WIDTH_SMALL = 100;
export const MULTI_OPENING_THUMB_HEIGHT_SMALL = 100;

const getShapeStyle = (openingShape) =>
  openingShape === 'oval' || openingShape === 'circle' ? { borderRadius: '50%' } : {};
const getCroppedPhotoStyle = (cropAttrs) => {
  const x = parseFloat(cropAttrs?.cropX ?? cropAttrs?.cropx);
  const y = parseFloat(cropAttrs?.cropY ?? cropAttrs?.cropy);
  const w = parseFloat(cropAttrs?.cropW);
  const h = parseFloat(cropAttrs?.cropH);
  if (!w || !h) return undefined;

  return {
    position: 'absolute',
    left: `${-(x / w) * 100}%`,
    top: `${-(y / h) * 100}%`,
    width: `${(100 / w) * 100}%`,
    height: `${(100 / h) * 100}%`,
    maxWidth: 'none',
  };
};

export const MultiOpeningMatSummaryThumbnail = ({
  lineItem,
  className,
  maxWidth = MULTI_OPENING_THUMB_WIDTH,
  maxHeight = MULTI_OPENING_THUMB_HEIGHT,
}) => {
  const product = findMultiOpeningProductByName(lineItem?.printSizeName || lineItem?.printSizeAttributes?.printSize);

  if (!product) {
    return (
      <img
        src={getLineItemThumbnailUrl(lineItem) ?? placeholderImage}
        alt="Line item"
        className={className}
      />
    );
  }

  const rects = computeOpeningRects(product);
  const matAspect = product.matWidth / product.matHeight;
  const photographs = lineItem?.photographs || [];
  const openingShape = lineItem?.frameMat?.openingShape || product.openingShape;
  const shapeStyle = getShapeStyle(openingShape);

  return (
    <div
      className={styles.mat}
      style={{
        '--mat-aspect': matAspect,
        '--mat-max-width': `${maxWidth}px`,
        '--mat-max-height': `${maxHeight}px`,
      }}
    >
      {rects.map((rect, index) => {
        const photo = photographs[index];
        const photoUrl = photo?.photographCroppedUrl || photo?.photographUrl;
        const croppedStyle = photo?.photographCroppedUrl
          ? undefined
          : getCroppedPhotoStyle(photo?.photographAttributes);

        return (
          <div
            key={rect.id}
            className={styles.opening}
            style={{
              left: `${rect.left}%`,
              top: `${rect.top}%`,
              width: `${rect.width}%`,
              height: `${rect.height}%`,
              ...shapeStyle,
            }}
          >
            {photoUrl && (
              <img
                src={photoUrl}
                alt={photo?.photoFileName || 'Preview'}
                className={styles.openingPhoto}
                style={croppedStyle}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
